import { createReducer } from '@reduxjs/toolkit';
import {
	fetchInspectionOverview,
	fetchInspectionOverviewResolved,
	fetchInspectionOverviewRejected,
	fetchInspectionStandardCodes,
	fetchInspectionStandardCodesResolved,
	fetchInspectionStandardCodesRejected,
} from '@Actions/inspections.actions';
import { InspectionTypesStoreState } from '@Types/inspections.types';

export const initialState: InspectionTypesStoreState = {
	isLoading: false,
	inspectionTypeList: [],
	codesByStandard: {},
};

const inspectionTypesReducer = createReducer(initialState, builder => {
	builder
		.addCase(fetchInspectionOverview, state => {
			state.isLoading = true;
		})
		.addCase(fetchInspectionOverviewResolved, (state, action) => {
			state.isLoading = false;
			state.inspectionTypeList = action.payload;
		})
		.addCase(fetchInspectionOverviewRejected, state => {
			state.isLoading = false;
		})
		.addCase(fetchInspectionStandardCodes, state => {
			state.isLoading = true;
		})
		.addCase(fetchInspectionStandardCodesResolved, (state, action) => {
			const { standard, codes } = action.payload;
			state.codesByStandard[standard] = codes;
			state.isLoading = false;
		})
		.addCase(fetchInspectionStandardCodesRejected, state => {
			state.isLoading = false;
		});
});

export default inspectionTypesReducer;
